/** Deep link to the existing API Ingest workspace History View. */
export function ingestHistoryViewHref(apiId: string): string {
  const id = String(apiId || '').trim();
  if (!id) return '/api-ingest';
  return `/api-ingest?api=${encodeURIComponent(id)}`;
}
